import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { StageGetSummaryByProjectIdStageId, StageGetSummaryByProjectIdStageIdResponse } from '../../api/dtos';


const getData = (response?: SWRResponse<StageGetSummaryByProjectIdStageIdResponse, StageGetSummaryByProjectIdStageIdResponse>) => {
    return response?.data
};
const getError = (response?: SWRResponse<StageGetSummaryByProjectIdStageIdResponse, StageGetSummaryByProjectIdStageIdResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useStageDetailsByProjectIdStageId = (projectId?: number, stageId?: number, configuration?: SWRConfiguration<StageGetSummaryByProjectIdStageIdResponse, StageGetSummaryByProjectIdStageIdResponse>) => {
    
    const request = useMemo(() => {
        return projectId && stageId ?
            () => {
                return new StageGetSummaryByProjectIdStageId({ projectId, stageId });
            } :
            undefined;
    }, [projectId, stageId])

    return useGet(request, { getData, getError }, configuration);
}

export default useStageDetailsByProjectIdStageId;